<template>
  <v-card class="p-4">
    <v-card-title class="pt-10" style="width:100%">
      Nos utilisateurs
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <template>
        <v-btn class="mx-2" small fab :loading="loading" :disabled="loading" @click="exportCSV"  data-toggle="tooltip" title="Export des données au format csv">
          <v-icon dark small>
            mdi-database-export
          </v-icon>
        </v-btn>
      </template>
    </v-card-title>

    <!-- Skeleton loader -->
    <v-skeleton-loader
      v-if="loading"
      type="table"
      :types="{ 'table': 'table-thead, table-tbody, table-tfoot', 'table-tbody': 'table-row-divider@12' }"
      min-width="100%"
    />

    <!-- Tableau -->
    <v-data-table
      :hidden="loading"
      :headers="headers"
      :items="filteredUsers"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      @page-count="pageCountChange"
      :server-items-length="totalItems"
      hide-default-footer
    >
      <template v-slot:item.last_connection="{ item }">
        <span v-if="item.last_connection">{{ item.last_connection | moment }}</span>
        <span v-else>Aucune connexion</span>
      </template>

      <template v-slot:item.hasPassword="{ item }">
        <v-icon v-if="item.hasPassword == 1" small color="green">mdi-checkbox-marked-circle</v-icon>
        <v-icon v-else small color="red">mdi-checkbox-blank-circle</v-icon>
      </template>

      <template v-slot:item.type="{ item }">
        <v-chip x-small class="pa-2" color="pink" text-color="white" v-if="item.type == '0'">Interne</v-chip>
        <v-chip x-small class="pa-2" color="blue" text-color="white" v-if="item.type == '1'">SSO</v-chip>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      color="#e6057d"
      class="pt-5"
    />
  </v-card>
</template>

<script>
import Api from "@/core/services/api.service";
import moment from "moment";

export default {
  name: "users",
  data() {
    return {
      loading: true,
      search: "", 
      headers: [
        { text: "Nom", value: "lastname", align: "start" }, 
        { text: "Prénom", value: "firstname", align: "start" }, 
        { text: "Droit utilisateur", value: "droit", align: "start" }, 
        { text: "Compte Activé", value: "hasPassword", align: "center" }, 
        { text: "Nombre de connexion", value: "nbConnexion", align: "start" }, 
        { text: "Dernière connexion", value: "last_connection", align: "start" }, 
        { text: "Nombre de vidéos visionnées", value: "videos_seen", align: "start" }, 
        { text: "Parcours complétés", value: "nbCourseFinish", align: "start" },
      ],
      users: [],
      totalItems: 0,
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
    };
  },
  filters: {
    moment: function(date) {
      return moment.parseZone(date).format("DD/MM/YYYY");
    },
  },
  computed: {
    filteredUsers() {
      if (!this.search) return this.users;
      return this.users.filter(user =>
        user.lastname?.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    getAllUsers() {
      this.loading = true;
      Api.post("cockpit-users")
        .then((response) => {
          if (response.data.status === "success") {
            this.users = response.data.data;
            this.totalItems = response.data.total;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des données:", error);
          this.loading = false;
        });
    },
    pageCountChange(pageCount) {
      this.pagination.pagesNumber = pageCount;
    },

    exportCSV() {
      const rows = [
        [
          "Type",
          "Nom",
          "Prénom",
          "Droit utilisateur",
          "Compte activé",
          "Nombre de connexion",
          "Dernière connexion",
          "Nombre de vidéos visionnées",
          "Parcours complétés"
        ],
        ...this.users.map(u => [
          u.type,
          u.lastname,
          u.firstname,
          u.droit,
          u.hasPassword == 1 ? "Oui" : "Non",
          u.nbConnexion,
          u.last_connection ? moment.parseZone(u.last_connection).format("DD/MM/YYYY") : "Aucune connexion",
          u.videos_seen,
          u.nbCourseFinish,
        ]),
      ];

      const csvContent = rows.map(e => e.map(val => `"${val}"`).join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "users.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  mounted() {
    this.getAllUsers();
  },
};
</script>

